import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

// Barrios
import CentroHistorico from "../pages/barrios/centro-historico/page";
import LaMalagueta from "../pages/barrios/la-malagueta/page";
import ElPalo from "../pages/barrios/el-palo/page";
import Pedregalejo from "../pages/barrios/pedregalejo/page";
import Teatinos from "../pages/barrios/teatinos/page";
import ElLimonar from "../pages/barrios/el-limonar/page";
import Churriana from "../pages/barrios/churriana/page";
import CarreteraDeCadiz from "../pages/barrios/carretera-de-cadiz/page";
import CruzDeHumilladero from "../pages/barrios/cruz-de-humilladero/page";
import BailenMiraflores from "../pages/barrios/bailen-miraflores/page";
import CiudadJardin from "../pages/barrios/ciudad-jardin/page";
import PuertoDeLaTorre from "../pages/barrios/puerto-de-la-torre/page";
import Campanillas from "../pages/barrios/campanillas/page";
import Huelin from "../pages/barrios/huelin/page";
import Soliva from "../pages/barrios/soliva/page";
import ElConsul from "../pages/barrios/el-consul/page";

// Servicios
import PersianasPage from "../pages/servicios/persianas/page";
import MosquiterasPage from "../pages/servicios/mosquiteras/page";
import MotorizacionPage from "../pages/servicios/motorizacion/page";

// Sobre Nosotros, Contacto y legales
import SobreNosotros from "../pages/sobre-nosotros/page";
import ContactoPage from "../pages/contacto/page";
import AvisoLegal from "../pages/aviso-legal/page";
import Privacidad from "../pages/privacidad/page";
import Cookies from "../pages/cookies/page";

// Guías
import GuiasIndex from "../pages/guias/index/page";
import GuiaCambiarCinta from "../pages/guias/como-cambiar-cinta-persiana/page";
import GuiaCambiarCuerda from "../pages/guias/como-cambiar-cuerda-persiana/page";
import GuiaNoSubeNiBaja from "../pages/guias/persiana-no-sube-ni-baja/page";
import GuiaAtascadaDescolgada from "../pages/guias/persiana-atascada-descolgada/page";
import GuiaRecogedor from "../pages/guias/reparar-recogedor-persiana/page";
import GuiaCambiarMotor from "../pages/guias/cambiar-motor-persiana/page";
import GuiaCambiarLamas from "../pages/guias/cambiar-lamas-persiana/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/sobre-nosotros", element: <SobreNosotros /> },
  { path: "/contacto", element: <ContactoPage /> },
  { path: "/aviso-legal", element: <AvisoLegal /> },
  { path: "/privacidad", element: <Privacidad /> },
  { path: "/cookies", element: <Cookies /> },
  // Servicios
  { path: "/servicios/persianas", element: <PersianasPage /> },
  { path: "/servicios/mosquiteras", element: <MosquiterasPage /> },
  { path: "/servicios/motorizacion", element: <MotorizacionPage /> },
  // Guías
  { path: "/guias", element: <GuiasIndex /> },
  { path: "/guias/como-cambiar-cinta-persiana", element: <GuiaCambiarCinta /> },
  { path: "/guias/como-cambiar-cuerda-persiana", element: <GuiaCambiarCuerda /> },
  { path: "/guias/persiana-no-sube-ni-baja", element: <GuiaNoSubeNiBaja /> },
  { path: "/guias/persiana-atascada-descolgada", element: <GuiaAtascadaDescolgada /> },
  { path: "/guias/reparar-recogedor-persiana", element: <GuiaRecogedor /> },
  { path: "/guias/cambiar-motor-persiana", element: <GuiaCambiarMotor /> },
  { path: "/guias/cambiar-lamas-persiana", element: <GuiaCambiarLamas /> },
  // Barrios
  { path: "/barrios/centro-historico", element: <CentroHistorico /> },
  { path: "/barrios/la-malagueta", element: <LaMalagueta /> },
  { path: "/barrios/el-palo", element: <ElPalo /> },
  { path: "/barrios/pedregalejo", element: <Pedregalejo /> },
  { path: "/barrios/teatinos", element: <Teatinos /> },
  { path: "/barrios/el-limonar", element: <ElLimonar /> },
  { path: "/barrios/churriana", element: <Churriana /> },
  { path: "/barrios/carretera-de-cadiz", element: <CarreteraDeCadiz /> },
  { path: "/barrios/cruz-de-humilladero", element: <CruzDeHumilladero /> },
  { path: "/barrios/bailen-miraflores", element: <BailenMiraflores /> },
  { path: "/barrios/ciudad-jardin", element: <CiudadJardin /> },
  { path: "/barrios/puerto-de-la-torre", element: <PuertoDeLaTorre /> },
  { path: "/barrios/campanillas", element: <Campanillas /> },
  { path: "/barrios/huelin", element: <Huelin /> },
  { path: "/barrios/soliva", element: <Soliva /> },
  { path: "/barrios/el-consul", element: <ElConsul /> },
  { path: "*", element: <NotFound /> },
];

export default routes;